import BstlArtikel from "@/entities/common/bstl_artikel"
import router from "@/router"
import RouteNames from "@/util/route_names"
import ProdukteLogic from "../produkte_logic"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import ConverterUtil from "@/util/converter_util"
import BPArtikelHinzufuegenRequest from "@/entities/common/pending/bp_artikel_hinzufuegen_request"
import IdRequest from "@/entities/common/request/id_request"
import ReservierungNeu from "@/entities/common/reservierung_neu"
import BPArtikelAnzahlRequest from "@/entities/common/pending/bp_artikel_anzahl_request"
import PreislisteZeitraumRequest from "@/entities/common/request/preisliste_zeitpunkt_request"
import PlisteProduktZeit from "@/entities/common/pliste_produkt_zeit"

export default class ReservierungVorbestellungLogic extends ProdukteLogic {
  reservierung: ReservierungNeu = null
  bestellungCompleted: boolean = false
  insertCompleted: boolean = false
  private _warenkorb: BstlArtikel[] = []

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.BESTELLUNG.VORBESTELLUNG.BESTAETIGEN,
    })
  }

  get warenkorb(): BstlArtikel[] {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  init() {
    this.reservierung = this.mainLogic.reservierung
    if (this.reservierung != null) this.loadPreislisten()

    this.mainLogic.reservierungListeners.push(() => {
      this.reservierung = this.mainLogic.reservierung
      if (this.reservierung != null) this.loadPreislisten()
    })
  }

  loadPreislisten() {
    var request = new PreislisteZeitraumRequest()
    request.zeitpunkt = this.reservierung.zeitVon

    request.filialeId = this.filiale.filialeId

    if (this.mainLogic.reservierung.vorbestellungPending) {
      this._warenkorb =
        this.mainLogic.reservierung.vorbestellungPending.artikelliste
    }

    this.loadError = false

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.preisliste = response.data.payload
        } else {
          this.loadError = true
        }
      })
      .catch(() => {
        this.loadError = true
      })
  }

  addArtikel(artikel: BstlArtikel) {
    this.insertWorking = true

    var request = new BPArtikelHinzufuegenRequest()
    request.id = this.reservierung.id
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)

    this.insertError = false

    Poster.postUser<RemoteResult<BstlArtikel>>(
      RestPaths.reservierungenVorbestellungPendingArtikelHinzufuegen,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this._warenkorb.push(response.data.payload)
          this.artikel = null
          this.artikelDialogVisible = false
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  backToOverview() {
    router.push({
      name: RouteNames.RESERVIERUNG.DETAILS,
      params: { reservierungId: this.reservierung.id },
    })
  }

  bestellungBestaetigen() {
    this.insertWorking = true
    this.insertError = false
    this.insertCompleted = false

    var request = new IdRequest()
    request.id = this.reservierung.id

    Poster.postUser<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingBestaetigen,
      request
    )
      .then((response) => {
        this.insertWorking = false
        if (response.data.success) {
          this.bestellungCompleted = true
          this.insertCompleted = true
        } else {
          this.insertError = true
        }
      })
      .catch(() => {
        this.insertWorking = false
        this.insertError = true
      })
  }

  get hasMindestbestellwert() {
    return false
  }

  get mindestbestellwert() {
    return 0
  }

  get kostenlosAb() {
    return 0
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.id
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = this.mainLogic.reservierung.id
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.reservierungenVorbestellungPendingArtikelAendern,
        request
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.id
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        this._warenkorb.splice(
          this._warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1
        )
        if (this._warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }
}